import { Button, Dialog, DialogBody, DialogClose, DialogContent, DialogFooter } from '@civilgrid/ui/components';
import DineroFactory from 'dinero.js';
import type { AsyncState } from 'react-use/lib/useAsyncFn';
import { Action } from '~/authorizations';
import Can from '~/authorizations/Can';
import type { GetCostOutput } from '~/common/billingUtils';
import type { Project } from '~/common/types';

const labelMap = {
  draft: 'Draft',
  proposal: 'Project Lite',
  project: 'Project',
  projectPlus: 'Project Plus',
};

interface Props {
  projectCost: AsyncState<GetCostOutput>;
  toBillingTier: Project['billingTier'];
  fromBillingTier: Project['billingTier'];
  onDiscard: () => void;
  onConfirm: () => void;
}

export default function ({ projectCost, toBillingTier, fromBillingTier, onDiscard, onConfirm }: Props) {
  const toCost = DineroFactory({
    amount: projectCost.value?.[toBillingTier]?.totalCost || 0,
  });
  const fromCost = DineroFactory({
    amount: projectCost.value?.[fromBillingTier]?.totalCost || 0,
  });

  return (
    <Dialog open onOpenChange={(isOpen) => !isOpen && onDiscard()}>
      <DialogContent
        title={`Upgrade to ${labelMap[toBillingTier]}`}
        className="z-[110] w-auto min-w-min max-w-[75vw]"
        overlayClassName="z-[100]"
        data-testid="project-billing-tier-dialog"
      >
        <DialogBody className="text-sm">
          <div>
            You will be invoiced <b>{toCost.subtract(fromCost).toFormat()}</b> for this {labelMap[toBillingTier]}. Are
            you sure?
          </div>
        </DialogBody>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="secondary" data-testid="project-billing-tier-cancel">
              Cancel
            </Button>
          </DialogClose>
          <Can action={Action.CreateProject}>
            <Button
              data-testid="project-billing-tier-confirm"
              onClick={() => {
                //close();
                onConfirm();
              }}
            >
              Yes
            </Button>
          </Can>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
